import { Component } from '@angular/core';

import { BreakpointService } from '@library/core/services';
import { AccountService } from '@library/modules/user';

@Component({
   selector: 'lib-account-select',
   templateUrl: './account-select.component.html',
   styleUrls: ['./account-select.component.scss']
})
export class AccountSelectComponent {

   loading = false;

   constructor(
      public account: AccountService,
      public breakpoints: BreakpointService,
   ) {}

   ngOnInit():void{
      this.account.isShipmentLoading$.subscribe(isLoading => {  
      // true - Continuous loading if First Group of Shipment Data has not loaded
      // false - Stop Continuous loading in Account Selection if First Shipment has loaded
         this.loading = isLoading ? true : false ;
      })

   }

   setActive( id: number ): void {
      this.account.switchAccount( id ).subscribe();
   }
}
